import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import axios from 'axios';
import { techStackData } from '../utils/mockData';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fallbackCategories = [
  { title: 'Cloud Platforms', items: techStackData.cloud },
  { title: 'IaC & Config', items: techStackData.iac },
  { title: 'Containers & Orchestration', items: techStackData.containers },
  { title: 'CI/CD & GitOps', items: techStackData.cicd },
  { title: 'Security & Compliance', items: techStackData.security },
  { title: 'Networking', items: techStackData.networking },
  { title: 'Observability', items: techStackData.observability },
  { title: 'Scripting', items: techStackData.scripting },
];

const TechStack = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [categories, setCategories] = useState(fallbackCategories);

  useEffect(() => {
    axios
      .get(`${API}/content/toolkit`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length) setCategories(res.data);
      })
      .catch(() => {});
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="techstack-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="section-header"
        >
          <h2 className="section-title">Technology toolkit</h2>
        </motion.div>

        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="techstack-grid"
        >
          {categories.map((category, idx) => (
            <motion.div key={idx} variants={itemVariants} className="techstack-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="category-items">
                {category.items.map((item, itemIdx) => (
                  <motion.span
                    key={itemIdx}
                    className="tech-item"
                    whileHover={{
                      scale: 1.05,
                      transition: { duration: 0.2 },
                    }}
                  >
                    {item}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechStack;
